// extracted by mini-css-extract-plugin
module.exports = {"generic-form-item":"generic-form-item-G-NtI5W","form-label":"form-label-1BM5H9A","input-wrapper":"input-wrapper-1zXdpdJ"};